<!-- Modal Add User Info -->
<div class="modal fade" id="addAdmin" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addAdminTitle">Invite User</h5>
        <button id="closeInviteAdmin" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddAdminForm()">&times;</span>
        </button>
      </div>
      <form name="adminInfo" #addAdminForm="ngForm" novalidate (ngSubmit)="onCreateAdmin(addAdminForm)">
        <div class="modal-body">
          <div class="row hide-x-scroll">
            <!-- <div class="col-lg-3 col-md-3 col-sm-3 col-4">
              <input class="hide" #adminPhoto name="adminPhoto" type="file" />
              <button class="btn btn-light rounded-circle upload-img-btn" (click)="adminPhoto.click()">Add
                Image</button>
            </div> -->
            <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!adminFormData.image">
                <img src="assets/images/person.jpg" class="img-thumbnail full-img">
              </div>
              <div *ngIf="adminFormData.image">
                <img [src]="adminFormData.image" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploadUserLogo id="uploadUserLogoInput" name="uploadUserLogoInput" type="file"
                  (click)="uploadUserLogo.value=null" (change)="uploadFleetB2BLogo($event)" accept=".jpg,.png">
              </div>
              <small><a style="cursor:pointer" (click)="changeuploadFleetB2BLogoClicked()"><u>Upload
                    Image</u></a></small>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group">
                <label for="adminName"><span class="maroon  astrisk">&#10033;&nbsp;</span>Name</label>
                <input type="text" class="form-control" id="adminName" name="adminName" placeholder="Name" required
                  [(ngModel)]="adminFormData.name" #adminName="ngModel">
                <small class="text-danger text-center" *ngIf="adminName.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="adminName.errors.required">*Required</p>
                </small>
              </div>
              <div class="form-group">
                <label for="adminEmail"><span class="maroon  astrisk">&#10033;&nbsp;</span>Email</label>
                <input type="email" class="form-control" id="adminEmail" name="adminEmail" placeholder="Email Address"
                  required [(ngModel)]="adminFormData.adminEmail" #adminEmail="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$">
                <small class="text-danger text-center" *ngIf="adminEmail.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="adminEmail.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!adminEmail.errors.required">Invalid email</p>
                </small>
              </div>
              <div class="form-group">
                <label for="adminPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span>Phone</label>
                <input type="text" class="form-control" id="adminPhone" pattern="[+][1][0-9]{10}" name="adminPhone"
                  placeholder="+1XXXXXXXXXX" maxlength="12" required [(ngModel)]="adminFormData.adminPhone"
                  #adminPhone="ngModel">
                <small class="text-danger text-center" *ngIf="adminPhone.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="adminPhone.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!adminPhone.errors.required">Invalid Phone</p>
                </small>
              </div>
              <div class="form-group">
                <label for="role"><span class="maroon astrisk">&#10033;&nbsp;</span>Select Role</label>
                <select id="model" class="w-100" id="role" aria-placeholder="Select Role"
                  [(ngModel)]="adminFormData.role" name="role" #role="ngModel">
                  <option *ngFor="let role of userRoles" value="{{role}}">{{role | customText}}</option>
                  <!-- <option value="ROLE_ACCOUNT_ADMIN">Account Admin</option>
                  <option value="ROLE_ACCOUNT_DEVELOPER">Developer</option>
                  <option value="ROLE_FLEET_OPERATOR">Fleet Operator</option>
                  <option value="ROLE_RENTER">Renter</option> -->
                  <!-- <option value="ROLE_FMC_DRIVER">Driver</option> -->
                </select>
              </div>
              <!-- <div class="form-group">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Select Role</label>
                <select id="model" class="w-100" aria-placeholder="Select Role" [(ngModel)]="adminFormData.role"
                  name="role" (change)="roleSelected($event)" #role="ngModel"> 
                  <option *ngFor= "let role of userRoles" value={{role}}>{{role | role_display}}</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetAddAdminForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">SAVE</button>
        </div>
      </form>
    </div>
  </div>
</div>